module.exports = __webpack_public_path__ + "static/logo-banner-f67537c3f965526004a6e89364787652.png";